import React, { useState, useCallback, useEffect } from "react";
import { getTranslation } from "../languageProvider";
import { SimpleForm } from "simple-ui-components";

export const FilterRepairType = ({ Filter }) => {
  const { InputGroup } = SimpleForm;

  const [name, setName] = useState("");
  const [isFilter, setIsFilter] = useState(false);

  const nameChangeHandler = useCallback((event) => {
    setName(event.target.value);
    setIsFilter(true);
  }, []);

  useEffect(() => {
    if (isFilter) {
      Filter(name);
      setIsFilter(false);
    }
  }, [isFilter, name, Filter]);
  return (
    <div className="outline md">
      <InputGroup
        type="input"
        className="noMargin"
        placeholder={`${getTranslation("0050")}/${getTranslation("0143")}`}
        inputElement={{
          name: "filterType",
          onChange: nameChangeHandler,
          type: "text",
          defaultValue: name,
          className: name ? "focused" : "",
          translate: "0050,0143",
        }}
      />
    </div>
  );
};
